import parsePath from './ParsePath';
import { isEmpty, isObject } from './util';

export default function treeAttribsParser(vnode, data, methods, key, watched, build_element) {
    if (vnode && vnode[key]) {
        _attribs = vnode[key];
        vnode[key] = '';
        let vnode_attribs = [];
        for(let attrib of _attribs) {
            if (!attrib) {
                continue;
            }
            if (!isObject(attrib) && !attrib.length) {
                continue;
            }
            if (attrib && attrib.is_function) {
                if (attrib.fun_name && attrib.fun_param) {
                    let fun_name = attrib.fun_name;
                    let fun_param = attrib.fun_param;
                    if (methods && typeof methods[fun_name] === 'function' && data && !isEmpty(data[fun_param])) {
                        let callResult = methods[fun_name](data[fun_param]);
                        vnode_attribs.push(callResult || '');
                    }
                }
            } else if (attrib && attrib.is_caculate) {
                try {
                    let handle_cal = new Function('with(this) { return ' + attrib.caculate + ' }');
                    let calResult = handle_cal.bind(data)();
                    vnode_attribs.push(calResult || '');
                    if (build_element && attrib.watched){
                        watched && watched.push(attrib.watched);
                    }
                } catch(e) {
                    console.log(e);
                }
            } else if (attrib && attrib.is_bind && attrib.bind) {
                vnode_attribs.push(parsePath(attrib.bind)(data) || '');
                if (build_element) watched && watched.push(attrib.bind.replace(/\s+/g, ''));
            } else if(!isObject(attrib)){
                vnode_attribs.push(attrib);
            }
        }
        vnode[key] = vnode_attribs.join(' ');
    }
}